import React from 'react';
import { ProfilePicture } from '../../../../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';
import { formatVP } from '../../../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P1 } from '../../../../../styles/FontStyles';
import {
  Flexed,
  UserImageCircle
} from '../../../../../styles/GlobalComponents';
import { color } from '../../../../../styles/GlobalStyles';

export const UserProfile = ({
  teamMember,
  teamMemberInfo,
  directTeamMemberInfo
}) => {
  const { t } = useTranslation('myTeam');
  // const hasFullName = teamMember?.name && teamMember.surname;

  function ordinal_suffix_of(i) {
    var j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + 'st';
    }
    if (j === 2 && k !== 12) {
      return i + 'nd';
    }
    if (j === 3 && k !== 13) {
      return i + 'rd';
    }
    return i + 'th';
  }

  return (
    <Flexed center column>
      <ProfilePicture
        size={'60px'}
        style={{ marginBottom: 15, marginRight: 0 }}>
        <UserImageCircle
          image={teamMember?.profileImageUrl}
          avatar
          avatarSize='30px'
          size='60px'
        />
      </ProfilePicture>

      <CaptionText center color={color.colors.neutral700}>
        {t('id')}: {teamMember?.id}
      </CaptionText>

      <P1
        bold
        center
        mb='15'
        color={color.colors.neutral700}
        style={{ maxWidth: '100%' }}>
        <div className='truncated'>
          <div>{teamMember?.username}</div>
        </div>
      </P1>

      <Flexed>
        <CaptionText center color={color.colors.neutral700}>
          {/* {t('direct_volume')}:{' '} */}
          Unilevel + PO:{' '}
        </CaptionText>
        <CaptionText center bold ml='8' color={color.colors.neutral700}>
          {formatVP(parseInt(teamMemberInfo?.directTotalVolume))}
        </CaptionText>
      </Flexed>

      {directTeamMemberInfo && directTeamMemberInfo?.generationLevel !== 0 && (
        <div
          style={{
            padding: '4px 8px',
            borderRadius: '8px',
            background: '#2E2A29',
            marginTop: 8
          }}>
          <CaptionText center color={color.colors.neutral50}>
            {ordinal_suffix_of(directTeamMemberInfo?.generationLevel)}{' '}
            {t('generation')}
          </CaptionText>
        </div>
      )}
    </Flexed>
  );
};
